import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export const confirmPassword : ValidatorFn = (control : AbstractControl) : ValidationErrors | null => {

  const password = control.get('password')
  const passwordConfirm = control.get('confirmPassword')

  if(password?.value != passwordConfirm?.value)
    return {confirmPassword : true}

  return null
}


export const checkDateEffet : ValidatorFn = (control : AbstractControl) : ValidationErrors | null => {

  const date = new Date(control.value).setHours(0,0,0,0)
  const current = new Date().setHours(0,0,0,0)

  if(date == 0)
    return null

  if(date < current)
    return {date : true}

  return null
}

export const checkBetweenDate : ValidatorFn = (control : AbstractControl) : ValidationErrors | null => {

  const date_debut = new Date(control.get('date_debut')?.value).setHours(0,0,0,0)
  const date_fin = new Date(control.get('date_fin')?.value).setHours(0,0,0,0)

  console.log('valid ', date_fin < date_debut);

  if(date_fin < date_debut)
    return {date : true}

  return null
}

